module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_registration-c545809829ab9ed83add79fdfd921740.svg&quot;;"